import React, { useEffect } from 'react'
import env from '../../../Config'

import './design.scss'
const WebDesign = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className='container-fluid base-pad pt-0'>
            <div>
                <div>
                    <img src={env.baseUrl + '/images/web-design-banner.jpg'} className='img-fluid' />
                </div>
            </div>
            <div className='bg-white p-3'>
                <div className='container-fluid'>
                    <div className='container-cust'>
                        <div className='row'>
                            <div className='col-lg-6 mt-5 pt-lg-5 pe-lg-4'>
                                <h6 class="sec-heading text-uppercase">Web Design</h6>
                                <h3 className='base-h2'>Web Design Service</h3>
                                <p>
                                    Web design is more than creating a visually attractive website it’s about building a fast, user-friendly, and engaging digital experience that strengthens your brand and supports your business goals. At CodexCore, we provide professional web design services that combine creative design, intuitive navigation, responsive layouts, and modern technologies to create websites that look great and perform seamlessly across desktops, tablets, and mobile devices. Our goal is to help businesses establish a strong online presence, engage their target audience, and turn website visitors into loyal customers.
                                </p>
                                <p>
                                    Our experienced web designers create customized websites tailored to your brand, industry, and unique business requirements. From modern UI/UX design and responsive web design to SEO-friendly structures and conversion-focused layouts, we follow industry best practices to deliver websites that are both visually appealing and search-engine friendly. Whether you are a startup, small business, or growing enterprise, CodexCore helps you build a high-performing website that enhances your brand, improves user experience, and supports long-term digital growth.
                                </p>
                            </div>
                            <div className='col-lg-6 mt-5'>
                                <img src={env.baseUrl + '/images/web-design.avif'} className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           <div className="container sec-pad">
    <h4 className="primary-text mb-3">Our Web Design Process</h4>

    <div className="row g-4">
        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-search me-2 secondary-text"></i>
                    Discovery & Research
                </div>
                <div className="card-body">
                    We begin by understanding your business goals, target audience, industry, and competitors. This helps us create a clear design strategy focused on your users and business objectives.
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-project-diagram me-2 secondary-text"></i>
                    Wireframing & Prototyping
                </div>
                <div className="card-body">
                    We create intuitive wireframes and interactive prototypes to define the website structure, navigation, and user journey before moving into the final design.
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-palette me-2 secondary-text"></i>
                    UI Design & Branding
                </div>
                <div className="card-body">
                    Our designers create modern and engaging interfaces that reflect your brand identity. We carefully select colors, typography, imagery, and visual elements to create a consistent experience.
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-edit me-2 secondary-text"></i>
                    Content & SEO Optimization
                </div>
                <div className="card-body">
                    We structure your website content for clarity, engagement, and search visibility. Our approach combines compelling copy, optimized headings, and SEO-friendly content structure.
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-code me-2 secondary-text"></i>
                    Development & Testing
                </div>
                <div className="card-body">
                    We transform designs into fast, responsive, and secure websites using modern web technologies. Every website is thoroughly tested across devices and browsers before launch.
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100">
                <div className="card-header fs-4">
                    <i className="las la-rocket me-2 secondary-text"></i>
                    Launch & Optimization
                </div>
                <div className="card-body">
                    After launch, we monitor performance and user experience to identify opportunities for improvement. We continuously optimize your website to support long-term growth and conversions.
                </div>
            </div>
        </div>
    </div>
</div>
        </div>
    )
}

export default WebDesign